(() => {
  if (window.bpEffects) {
    window.bpEffects.init(document);
    return;
  }
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const pointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const observers = new Set();
  const cleanups = new Map();
  let scrollFrame = 0;
  const updateHeader = () => {
    scrollFrame = 0;
    document.querySelectorAll('.bp-header').forEach(header => {
      header.classList.toggle('bp-is-scrolled', window.scrollY > 12);
    });
  };
  const init = scope => {
    updateHeader();
    scope.querySelectorAll('.bp-desktop-nav a, .bp-mobile-nav nav a').forEach(link => {
      const path = (link.pathname || '').replace(/\/$/, '');
      if (path === window.location.pathname.replace(/\/$/, '') && path !== '') {
        link.setAttribute('aria-current', 'page');
      }
    });
    scope.querySelectorAll('.bp-home').forEach(home => {
      if (cleanups.has(home)) return;
      const controller = new AbortController();
      const targets = Array.from(home.querySelectorAll('.bp-categories h2, .bp-category, .bp-roof'));
      let observer;
      if (!motion.matches && 'IntersectionObserver' in window && !window.Shopify?.designMode) {
        observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('bp-visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: .1 });
        observers.add(observer);
        targets.forEach((target, i) => {
          target.style.setProperty('--bp-reveal-delay', `${Math.min(i % 7, 5) * 55}ms`);
          target.classList.add('bp-reveal');
          observer.observe(target);
        });
      }
      const hero = home.querySelector('.bp-hero');
      let frame = 0;
      let nextX = 0;
      let nextY = 0;
      const resetHero = () => {
        cancelAnimationFrame(frame);
        frame = 0;
        hero?.style.removeProperty('--bp-hero-x');
        hero?.style.removeProperty('--bp-hero-y');
      };
      if (hero) {
        hero.addEventListener('pointermove', event => {
          if (motion.matches || !pointer.matches || event.pointerType !== 'mouse') return;
          const bounds = hero.getBoundingClientRect();
          nextX = ((event.clientX - bounds.left) / bounds.width - .5) * 10;
          nextY = ((event.clientY - bounds.top) / bounds.height - .5) * 6;
          if (frame) return;
          frame = requestAnimationFrame(() => {
            frame = 0;
            hero.style.setProperty('--bp-hero-x', `${nextX.toFixed(2)}px`);
            hero.style.setProperty('--bp-hero-y', `${nextY.toFixed(2)}px`);
          });
        }, { signal: controller.signal });
        hero.addEventListener('pointerleave', resetHero, { signal: controller.signal });
      }
      const showAll = () => {
        if (!motion.matches) return;
        observer?.disconnect();
        targets.forEach(target => target.classList.add('bp-visible'));
        resetHero();
      };
      motion.addEventListener('change', showAll, { signal: controller.signal });
      cleanups.set(home, () => {
        controller.abort();
        resetHero();
        observer?.disconnect();
        observers.delete(observer);
        targets.forEach(target => target.classList.remove('bp-reveal', 'bp-visible'));
      });
    });
  };
  window.bpEffects = { init };
  window.addEventListener('scroll', () => {
    if (!scrollFrame) scrollFrame = requestAnimationFrame(updateHeader);
  }, { passive: true });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.bp-home').forEach(home => {
      cleanups.get(home)?.();
      cleanups.delete(home);
    });
  });
  document.addEventListener('shopify:block:select', event => {
    event.target.closest('.bp-reveal')?.classList.add('bp-visible');
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }
})();
